module.exports = __webpack_public_path__ + "vyhlazeni-vrasek-metodou-derma-k_10_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/vyhlazeni-vrasek-metodou-derma-k_10_after.jpg
// module id = 1229
// module chunks = 0